module.exports = __webpack_public_path__ + "static/media/mtnl_logo.bb273910.png";